// Generated by CoffeeScript 2.7.0
var Graph;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import Edge from './edge.js';

import Vertex from './vertex.js';

import Ajax from 'libs/ajax.js';

export default Graph = {
  props: {
    graph: Skylark.App.Model.YetAnotherWorkflow.Graph,
    vertexSize: Object,
    zoom: Number,
    minSize: Object
  },
  components: {
    vertex: Vertex,
    edge: Edge
  },
  data: function() {
    return {
      selectedVertices: [],
      selectedEdges: [],
      preparedVertex: null,
      preparedEdge: null,
      selectBox: {
        // 记录鼠标按下时的坐标
        start: [0, 0],
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        visible: false
      },
      dragStates: {
        start: {
          x: 0,
          y: 0
        },
        dir: 1,
        enable: false,
        original_data: [],
        key: 'from'
      },
      prepareToCopyVertex: null
    };
  },
  provide: function() {
    return {
      'adjustByZoom': this.adjustByZoom
    };
  },
  // SVG 和 节点直接平级的原因：
  //   如果不是平级，节点被容器包围时，容器在SVG上方，此时所有的操作，SVG都都检测不到
  template: `<div class="editor-container">
  <div class="graph-editor" :style='graphEditorStyleObj'>
    <svg xmlns="http://www.w3.org/2000/svg"
         class='edges-container'
         :style='svgStyleObj'
         @mousedown.stop='mousedownFunc'
         @focus='focusFunc'
         @keyup.delete='deleteSelectedFunc'
         ref='svgRef'>
      <rect class="select-box"
            :x='selectBox.left'
            :y='selectBox.top'
            :width='selectBox.width'
            :height='selectBox.height'
            v-if='selectBox.visible' />
      <edge :edge='preparedEdge'
            :vertexSize='vertexSize'
            :zoom='zoom'
            v-if='preparedEdge'
            :dragStates='dragStates' />
      <edge v-for='edge in graph.edges'
            :edge='edge'
            :key='edge.uuid'
            :selectedEdges='selectedEdges'
            :vertexSize='vertexSize'
            :dragStates='dragStates'
            :zoom='zoom'
            @focusEdge='focusEdgeFunc'
            @addPreparedEdge='addPreparedEdgeFunc'
            @prepareEdgeEnd='prepareEdgeEndFunc' />
    </svg>
    <vertex v-for='vertex in vertexLikeVertices'
            :vertex='vertex'
            :key='vertex.uuid'
            :selectedVertices='selectedVertices'
            :vertexSize='vertexSize'
            :dragStates='dragStates'
            :zoom='zoom'
            @enterChildGraph='enterChildGraphFunc'
            @addPreparedEdge='addPreparedEdgeFunc'
            @enterVertex='enterVertexFunc'
            @leaveVertex='leaveVertexFunc'
            @focusVertex='focusVertexFunc'
            @prepareEdgeEnd='prepareEdgeEndFunc'
            @limitVerticesPosition='limitVerticesPositionFunc' />
  </div>
  <vertex :vertex='preparedVertex'
          :dragStates='dragStates'
          :vertexSize='vertexSize'
          :zoom='zoom'
          ref='preparedVertexRef'
          :isPreparedVertex='true'
          v-if='preparedVertex' />
</div>`,
  computed: {
    vertexLikeVertices: function() {
      return this.graph.getVertexLikeVertices();
    },
    graphEditorStyleObj: function() {
      return {
        zoom: this.zoom / 10
      };
    },
    svgStyleObj: function() {
      var buffer;
      buffer = 100;
      return {
        minWidth: this.minSize.x + this.vertexSize.width + buffer,
        minHeight: this.minSize.y + this.vertexSize.height + buffer
      };
    }
  },
  created: function() {
    return _.each(['mousemove', 'mouseup', 'addVertexBtnMouseup'], (event_type) => {
      return this[`${event_type}Func`] = this[event_type].bind(this);
    });
  },
  watch: {
    graph: function() {
      this.selectedVertices = [];
      return this.resetPrepareToCopyVertex();
    }
  },
  methods: {
    focusFunc: function() {},
    enterChildGraphFunc: function(vertex) {
      return this.$emit('enterChildGraph', vertex);
    },
    limitVerticesPositionFunc: function(vertices) {
      var max_left, max_top, svg_rect;
      svg_rect = this.$refs.svgRef.getBoundingClientRect();
      max_left = svg_rect.width - this.vertexSize.width;
      max_top = svg_rect.height - this.vertexSize.height;
      return _.each(vertices, function(vertex) {
        var x, y;
        ({x, y} = vertex.metadata.position);
        vertex.metadata.position.x = Math.min(Math.max(0, x), max_left);
        return vertex.metadata.position.y = Math.min(Math.max(0, y), max_top);
      });
    },
    selectVertices: function() {
      this.selectedVertices = _.filter(this.vertexLikeVertices, (vertex) => {
        var _position, ref, ref1;
        _position = vertex.metadata.position;
        return (0 < (ref = _position.x - this.selectBox.left) && ref < this.selectBox.width - this.vertexSize.width) && (0 < (ref1 = _position.y - this.selectBox.top) && ref1 < this.selectBox.height - this.vertexSize.height);
      });
      this.selectedEdges = this.graph.getEdgesOfVertices(this.selectedVertices);
      return this.$emit('selectedChanged', this.selectedVertices.length === 1 ? this.selectedVertices[0] : this.graph);
    },
    deleteSelectedFunc: function() {
      var _selectedGraphs, _selectedVertices, graphs, vertices;
      if (this.selectedVertices.length) {
        _selectedGraphs = _.filter(this.selectedVertices, function(vertex) {
          return Skylark.App.Model.YetAnotherWorkflow.Graph.hasInstance(vertex);
        });
        _selectedVertices = _.difference(this.selectedVertices, _selectedGraphs);
        graphs = _.filter(_selectedGraphs, function(graph) {
          if (graph.enableDelete()) {
            return true;
          }
          newAlertify(`${graph.errors.fullMessageFor('graph')}`, {
            type: 'error'
          });
          return false;
        });
        vertices = _.filter(_selectedVertices, function(vertex) {
          if (vertex.enableDelete()) {
            return true;
          }
          newAlertify(`${vertex.errors.fullMessageFor('vertex')}`, {
            type: 'error'
          });
          return false;
        });
        Ajax.delete(`/admin${this.graph.flow.gid.toPath()}/graphs/destroy_collection`, {
          contentType: 'application/json; charset=utf-8',
          data: {
            graph_ids: _.pluck(graphs, 'id'),
            vertex_ids: _.pluck(vertices, 'id')
          },
          success: function() {
            return _.each(_.union(graphs, vertices), function(element) {
              return element.deleteSucceeded();
            });
          }
        });
      } else {
        _.each(this.selectedEdges, function(edge) {
          if (!edge.delete()) {
            return newAlertify(`${edge.errors.fullMessageFor('edge')}`, {
              type: 'error'
            });
          }
        });
      }
      this.selectedVertices = [];
      this.selectedEdges = [];
      return this.$emit('selectedChanged', this.graph);
    },
    focusEdgeFunc: function(edge) {
      return this._focusEdge(edge);
    },
    focusVertexFunc: function(vertex) {
      return this._focusVertex(vertex);
    },
    // 添加或修改边时，有一端的点还没有确定时的逻辑处理
    // 此时边的状态为 uncentainVertex
    // 2端的点都确定了（拖动进了某一个节点），但手还未松开时
    // 边的状态为 'temporary'
    addPreparedEdgeFunc: function(edge, prev_edge) {
      if (this.preparedEdge && this.preparedEdge._status === 'temporary') {
        return;
      }
      if (edge) {
        this.preparedEdge = Skylark.App.Model.YetAnotherWorkflow.Edge.new(edge, this.graph);
      } else {
        this.preparedEdge = null;
      }
      return this.preparedEdge.prev_edge = prev_edge;
    },
    // 鼠标进入某个节点时的处理, dir 为进入方向
    enterVertexFunc: function(vertex, dir) {
      var centain_key, exist_edge, from, special_key, to, uncentain_key;
      if (!this.preparedEdge) {
        return;
      }
      uncentain_key = this.preparedEdge.metadata.uncentain_key;
      centain_key = uncentain_key === 'from' ? 'to' : 'from';
      // 不能连入开始节点
      if (vertex.isInitial && uncentain_key === 'to') {
        return;
      }
      // 开始节点不能直接连入终止节点
      if (vertex.isFinal && this.preparedEdge[centain_key].isInitial) {
        return;
      }
      // 起止都为同一节点时，不处理
      if (vertex === this.preparedEdge[centain_key]) {
        return;
      }
      // 如果进入的节点是子图，则根据边的起/止决定链接入子图的结束/开始节点
      if (Skylark.App.Model.YetAnotherWorkflow.Graph.hasInstance(vertex)) {
        special_key = uncentain_key === 'to' ? 'initial_vertex' : 'final_vertex';
        vertex = vertex[special_key];
      }
      if (uncentain_key === 'from') {
        from = vertex;
        to = this.preparedEdge.to;
      } else {
        from = this.preparedEdge.from;
        to = vertex;
      }
      // 如果连接的2个节点已经存在边且当前修改的边不同于存在的边
      // (从别的边改线到已经存在的边)
      // 则不能连入该节点
      // 新建的边如果存在，则更新链接方向
      exist_edge = this.graph.getEdgeBetweenTwoVertices(from, to);
      if (exist_edge && (this.preparedEdge.prev_edge && exist_edge !== this.preparedEdge.prev_edge)) {
        return;
      }
      this.preparedEdge[uncentain_key] = vertex;
      this.preparedEdge.setStatus('temporary');
      return this.preparedEdge.metadata.connection_direction[uncentain_key] = dir;
    },
    // 鼠标移出某个节点时的处理
    leaveVertexFunc: function(vertex) {
      var centain_key, uncentain_key;
      if (!this.preparedEdge) {
        return;
      }
      uncentain_key = this.preparedEdge.metadata.uncentain_key;
      centain_key = uncentain_key === 'from' ? 'to' : 'from';
      if (vertex === this.preparedEdge[centain_key]) {
        return;
      }
      // 此处置空是可以的，它的下一步是addPreparedEdgeFunc
      return this.preparedEdge = null;
    },
    // 添加或修改边，松手时的处理逻辑
    // 如果有 prev_edge，则为修改边
    prepareEdgeEndFunc: function(prev_edge) {
      var exist_edge;
      if (!this.preparedEdge) {
        return;
      }
      if (this.preparedEdge._status === 'temporary') {
        if (prev_edge) {
          // 新边和修改前一样时，更新之前的边的方向
          prev_edge.metadata.connection_direction = this.preparedEdge.metadata.connection_direction;
          // 否则，除了更新之前边的方向，还要更新节点
          if (!(prev_edge.from === this.preparedEdge.from && prev_edge.to === this.preparedEdge.to)) {
            prev_edge.from = this.preparedEdge.from;
            prev_edge.to = this.preparedEdge.to;
          }
          prev_edge.update();
          prev_edge.setStatus('normal');
          return this.preparedEdge = null;
        } else {
          exist_edge = this.graph.getEdgeBetweenTwoVertices(this.preparedEdge.from, this.preparedEdge.to);
          // 新建的边的起始点已经存在一条边时，不再新建，只更新边的连线
          if (exist_edge) {
            exist_edge.metadata.connection_direction = this.preparedEdge.metadata.connection_direction;
            exist_edge.update();
            return this.preparedEdge = null;
          } else {
            this.preparedEdge.setStatus('normal');
            return this.graph.createEdge(this.preparedEdge).complete(() => {
              return this.preparedEdge = null;
            });
          }
        }
      } else {
        // 修改边时，如果新边有不确定的点，应舍弃新边，使用旧边(保留条件)
        if (prev_edge) {
          prev_edge.setStatus('normal');
        }
        return this.preparedEdge = null;
      }
    },
    // 添加节点逻辑，节点的拖动使用vertex组件完成，外部不处理，外部只需要知道有没有添加成功即可
    addPreparedVertex: function(type, position, event) {
      this.preparedVertex = this._gennerateVertexLikeVertex(type, position);
      this.$nextTick(function() {
        return this.$refs.preparedVertexRef.mousedownFunc(event);
      });
      return this._addListener('mouseup', this.addVertexBtnMouseupFunc);
    },
    addVertexBtnMouseup: function(event) {
      var position, ref, ref1, svg_rect, x_in_range, y_in_range;
      this._removeListener('mouseup', this.addVertexBtnMouseupFunc);
      if (!this.preparedVertex) {
        return;
      }
      this._calculatePositionWithZoom(this.preparedVertex);
      position = this.preparedVertex.metadata.position;
      svg_rect = this.$refs.svgRef.getBoundingClientRect();
      y_in_range = (-this.vertexSize.height / 2 < (ref = position.y) && ref < svg_rect.height - this.vertexSize.height / 2);
      x_in_range = (-this.vertexSize.width / 2 < (ref1 = position.x) && ref1 < svg_rect.width - this.vertexSize.width / 2);
      if (y_in_range && x_in_range) {
        if (Skylark.App.Model.YetAnotherWorkflow.Graph.hasInstance(this.preparedVertex)) {
          return this.graph.createChildGraph(this.preparedVertex).success((data, status, xhr) => {
            var new_child;
            return new_child = _.last(this.graph.children);
          }).complete(() => {
            return this.preparedVertex = null;
          });
        } else {
          return this.graph.createVertex(this.preparedVertex).success((data, status, xhr) => {
            var new_vertex;
            return new_vertex = _.last(this.graph.vertices);
          }).complete(() => {
            return this.preparedVertex = null;
          });
        }
      } else {
        return this.preparedVertex = null;
      }
    },
    // 框选逻辑
    mousedownFunc: function(event) {
      var svg_rect;
      // 鼠标右键
      if (event.which !== 1) {
        return;
      }
      svg_rect = this.$refs.svgRef.getBoundingClientRect();
      this.selectBox.svg_rect = svg_rect;
      this.selectBox.start = [this.adjustByZoom(event.offsetX) + svg_rect.left, this.adjustByZoom(event.offsetY) + svg_rect.top];
      this.selectBox.left = this.adjustByZoom(event.offsetX);
      this.selectBox.top = this.adjustByZoom(event.offsetY);
      this._addListener('mousemove', this.mousemoveFunc);
      return this._addListener('mouseup', this.mouseupFunc);
    },
    mousemove: function(event) {
      this.selectBox.visible = true;
      return this._resizeSelectBox(event);
    },
    mouseup: function(event) {
      this._removeListener('mousemove', this.mousemoveFunc);
      this._removeListener('mouseup', this.mouseupFunc);
      if (this.selectBox.visible) {
        this._resizeSelectBox(event);
        this.selectBox.visible = false;
        return this.selectVertices();
      } else {
        // blur selected element and focus to graph
        return this._resetSelected();
      }
    },
    // 对齐逻辑
    // dir: vertical | horizontal
    alignSelectedVertices: function(dir = 'vertical') {
      var end_position, index;
      if (this.selectedVertices.length === 0) {
        return;
      }
      index = dir === 'vertical' ? 'x' : 'y';
      end_position = _.average(_.map(this.selectedVertices, function(vertex) {
        return vertex.metadata.position[index];
      }));
      return _.each(this.selectedVertices, function(vertex) {
        vertex.updatePosition({
          [`${index}`]: parseInt(end_position)
        });
        return vertex.update();
      });
    },
    adjustByZoom: function(value) {
      return value / this.zoom * 10;
    },
    copySelectedFunc: function() { // copy
      var vertex;
      if (this.selectedVertices.length !== 1) {
        return;
      }
      vertex = this.selectedVertices[0];
      if (vertex.isInitial || vertex.isFinal) {
        return newAlertify('开始节点和结束节点不能复制', {
          type: 'error'
        });
      } else {
        return this.prepareToCopyVertex = vertex;
      }
    },
    pasteCopyedFunc: function() { // paste
      var _position, offset;
      if (!this.prepareToCopyVertex) {
        return;
      }
      _position = this.prepareToCopyVertex.metadata.position;
      offset = 100;
      return this.prepareToCopyVertex.copy({
        metadata: {
          position: {
            x: _position.x + offset,
            y: _position.y + offset
          }
        }
      }).success(() => {
        return newAlertify(`复制节点 ${this.prepareToCopyVertex.name} 成功`, {
          type: 'success'
        });
      });
    },
    copyAndPasteSelectedFunc: function() {
      this.copySelectedFunc();
      return this.pasteCopyedFunc();
    },
    resetPrepareToCopyVertex: function() {
      return this.prepareToCopyVertex = null;
    },
    _resetSelected: function() {
      this.selectedEdges = [];
      this.selectedVertices = [];
      return this.$emit('selectedChanged', this.graph);
    },
    _resizeSelectBox: function(event) {
      var delta, svg_rect;
      svg_rect = this.selectBox.svg_rect;
      delta = {
        x: this.adjustByZoom(event.clientX) - this.selectBox.start[0],
        y: this.adjustByZoom(event.clientY) - this.selectBox.start[1]
      };
      if (delta.x < 0) {
        this.selectBox.left = this.selectBox.start[0] - svg_rect.left + delta.x;
      }
      if (delta.y < 0) {
        this.selectBox.top = this.selectBox.start[1] - svg_rect.top + delta.y;
      }
      this.selectBox.width = Math.abs(delta.x);
      return this.selectBox.height = Math.abs(delta.y);
    },
    _gennerateVertexLikeVertex: function(type, position) {
      switch (type) {
        case 'vertex':
          return Skylark.App.Model.YetAnotherWorkflow.Vertex.new({
            name: '流程节点',
            metadata: {
              position: position
            }
          }, this.graph);
        case 'child':
          return this.graph.generateChildGraph({
            metadata: {
              position: position
            }
          });
        case 'automation':
          return Skylark.App.Model.YetAnotherWorkflow.Vertex.new({
            name: '机器节点',
            metadata: {
              position: position
            },
            automation_agent: {
              webhook_secret: '输入 secret'
            }
          }, this.graph);
      }
    },
    _addListener: function(type, fn) {
      return document.body.addEventListener(type, fn, false);
    },
    _removeListener: function(type, fn) {
      return document.body.removeEventListener(type, fn, false);
    },
    _focusVertex: function(vertex) {
      this.selectedVertices = [vertex];
      this.selectedEdges = [];
      this.$refs.svgRef.focus();
      return this.$emit('selectedChanged', vertex);
    },
    _focusEdge: function(edge) {
      this.selectedEdges = [edge];
      this.selectedVertices = [];
      return this.$emit('selectedChanged', edge);
    },
    _calculatePositionWithZoom: function(element) {
      return _.each(element.metadata.position, (v, k) => {
        return element.metadata.position[k] = this.adjustByZoom(v);
      });
    }
  }
};
